import Header from "../components/landingComponents/Header";
import Hero from "../components/landingComponents/Hero";
import CandleStickPattern from "../components/landingComponents/LiveChart";
import TradingSteps from "../components/landingComponents/TradingSteps";
import AttractiveFeatures from "../components/landingComponents/AttractiveFeatures";
import SubscriptionPlan from "../components/landingComponents/SubscriptionPlan";
import FAQs from "../components/landingComponents/FAQs";
import Contact from "../components/landingComponents/Contact";
import Coin from "../components/landingComponents/Coin";
import Footer from "../components/landingComponents/Footer";
import "./LandingPage.css";

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <CandleStickPattern />
      <TradingSteps />
      <AttractiveFeatures />
      <SubscriptionPlan />
      <FAQs />
      <Contact />
      <Footer />
      <Coin />
    </div>
  );
};

export default LandingPage;
